import { useChargebackLogs } from './hooks/useChargebackLogs';
import ChargebackLogsView from './view';

export default function ChargebackLogs({ communityId, userId, username }) {
    const state = useChargebackLogs(communityId, userId);
    return <ChargebackLogsView {...state} username={username} />;
}
